// extracted by mini-css-extract-plugin
module.exports = {"container":"FeatureVideo_container___bm2o","videoContainer":"FeatureVideo_videoContainer__3F2oM"};